export default "__VITE_ASSET__B82$ohpr__"